<template>
  <div class="add-ccxs">
    <my-title the-title="财产线索" />
    <div class="fd-com-warning-tip">
      温馨提示：若您未找到相应的财产类型或未明确具体的财产线索时，请选择【其他】
    </div>
      <van-cell-group class="fd-com-scroll">
        <van-field
          required
          clearable
          readonly
          label="财产类型"
          placeholder="请选择财产类型"
          right-icon="arrow"
          v-model="formData.cCclxText"
          @click="showCCLX = true"
        ></van-field>
        <van-popup v-model="showCCLX" position="bottom">
          <van-picker
            show-toolbar
            :columns="codeList_112000"
            :default-index="0"
            @cancel="showCCLX = false"
            @confirm="onCCLXConfirm"
          ></van-picker>
        </van-popup>
        <van-field
          v-model="formData.cSqdbccyyzText"
          required
          clearable
          readonly
          label="财产所有人"
          placeholder="请选择财产所有人"
          right-icon="arrow"
          @click="showCCSYR = true"
        ></van-field>
        <van-popup v-model="showCCSYR" position="bottom">
          <van-picker
            show-toolbar
            :columns="columnsBSQRS"
            :default-index="0"
            @cancel="showCCSYR = false"
            @confirm="onCCSYRConfirm"
          ></van-picker>
        </van-popup>
        <!--货币现金-->
        <div v-if="cclxCode == 1">
          <van-field
            v-model="formData.cXjzje"
            required
            clearable
            label="数额"
            placeholder="请输入数额"
          ></van-field>
          <van-field
            required
            clearable
            readonly
            label="币种"
            placeholder="请选择币种"
            right-icon="arrow"
            v-model="formData.cCclxzbzText"
            @click="showBZLX = true"
          ></van-field>
          <van-popup v-model="showBZLX" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_119000"
              :default-index="0"
              @cancel="showBZLX = false"
              @confirm="onBZConfirm"
            ></van-picker>
          </van-popup>
        </div>
        <!--存款-->
        <div v-if="cclxCode == 2">
          <van-field
            required
            clearable
            readonly
            label="开户行所在地"
            placeholder="请选择开户行所在地"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cKhhmc"
            required
            clearable
            label="开户银行名称"
            placeholder="请选择开户银行名称"
          ></van-field>
          <van-field
            v-model="formData.cYhckzkhzh"
            required
            clearable
            label="开户账号"
            placeholder="请选择开户账号"
          ></van-field>
          <van-field
            v-model="formData.cYhckzckje"
            required
            clearable
            label="数额"
            placeholder="请输入数额"
          ></van-field>
          <van-field
            required
            clearable
            readonly
            label="币种"
            placeholder="请选择币种"
            right-icon="arrow"
            v-model="formData.cCclxzbzText"
            @click="showBZLX = true"
          ></van-field>
          <van-popup v-model="showBZLX" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_119000"
              :default-index="0"
              @cancel="showBZLX = false"
              @confirm="onBZConfirm"
            ></van-picker>
          </van-popup>
        </div>
        <!--交通运输工具-->
        <div v-if="cclxCode == 3">
          <van-field
            required
            clearable
            readonly
            label="车辆归属地"
            placeholder="请输入车辆归属地"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxzclpp"
            clearable
            label="车辆品牌"
            placeholder="请输入车辆品牌"
          ></van-field>
          <van-field
            v-model="formData.cCclxcllxText"
            clearable
            readonly
            right-icon="arrow-down"
            label="车辆类型"
            placeholder="请选择车辆类型"
            @click="showCLLX = true"
          ></van-field>
          <van-popup v-model="showCLLX" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_132000"
              :default-index="0"
              @cancel="showCLLX = false"
              @confirm="onCLLXConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCklxzcldcph"
            required
            clearable
            label="车牌号"
            placeholder="请输入车牌号"
          ></van-field>
        </div>
        <!--房产-->
        <div v-if="cclxCode == 4">
          <van-field
            required
            clearable
            readonly
            label="房屋坐落省份"
            placeholder="请输入房屋坐落省份"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxfcdz"
            required
            clearable
            label="房屋坐落位置"
            placeholder="请输入房屋坐落位置"
          ></van-field>
          <van-field
            v-model="formData.cCclxfczh"
            clearable
            label="房产证号"
            placeholder="请输入房产证号"
          ></van-field>
        </div>
        <!--土地使用权-->
        <div v-if="cclxCode == 5">
          <van-field
            required
            clearable
            readonly
            label="土地归属地"
            placeholder="请输入土地归属地"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxtdddz"
            required
            clearable
            label="地址"
            placeholder="请输入地址"
          ></van-field>
          <van-field
            v-model="formData.cCclxtdmj"
            required
            clearable
            label="面积"
            placeholder="请输入面积"
          ></van-field>
          <van-field
            v-model="formData.cYhckzckdwText"
            required
            clearable
            disabled
            right-icon="arrow-down"
            label="单位"
            placeholder="请输入单位"
            @click="showTDDW = true"
          ></van-field>
          <van-popup v-model="showTDDW" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_131000"
              :default-index="0"
              @cancel="showTDDW = false"
              @confirm="onTDDWLXConfirm"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxtddcqzh"
            clearable
            label="产权证号"
            placeholder="请输入产权证号"
          ></van-field>
        </div>
        <!--股票-->
        <div v-if="cclxCode == 6">
          <van-field
            required
            clearable
            readonly
            label="发行单位注册地"
            placeholder="请输入发行单位注册地"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxzgpdgpmc"
            required
            clearable
            label="股票名称"
            placeholder="请输入股票名称"
          ></van-field>
          <van-field
            v-model="formData.cCclxzgqdgsxx"
            clearable
            label="股票代码"
            placeholder="请输入股票代码"
          ></van-field>
          <van-field
            v-model="formData.cCclxzgpdcgsl"
            clearable
            label="持股数量(股)"
            placeholder="请输入持股数量"
          ></van-field>
        </div>
        <!--基金-->
        <div v-if="cclxCode == 7">
          <van-field
            required
            clearable
            readonly
            label="发行单位注册地"
            placeholder="请输入发行单位注册地"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxzjjdjjmc"
            required
            clearable
            label="基金名称"
            placeholder="请输入基金名称"
          ></van-field>
          <van-field
            v-model="formData.cCclxzjjdjjsl"
            clearable
            label="基金数量(份)"
            placeholder="请输入基金数量"
          ></van-field>
        </div>
        <!--债券-->
        <div v-if="cclxCode == 8">
          <van-field
            required
            clearable
            readonly
            label="发行单位注册地"
            placeholder="请输入发行单位注册地"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxzzwdzqmc"
            required
            clearable
            label="债券名称"
            placeholder="请输入债券名称"
          ></van-field>
          <van-field
            v-model="formData.cCclxzzwdzqmz"
            required
            clearable
            label="债券面值(元)"
            placeholder="请输入债券面值"
          ></van-field>
        </div>
        <!--股权-->
        <div v-if="cclxCode == 9">
          <van-field
            required
            clearable
            readonly
            label="发行单位注册地"
            placeholder="请输入发行单位注册地"
            right-icon="arrow"
            v-model="formData.cKhhszdText"
            @click="showKhhszd = true"
          ></van-field>
          <van-popup v-model="showKhhszd" position="bottom">
            <van-picker
              show-toolbar
              :columns="codeList_805000"
              :default-index="0"
              @cancel="showKhhszd = false"
              @confirm="confirmKhhszd"
            ></van-picker>
          </van-popup>
          <van-field
            v-model="formData.cCclxzgqdcggs"
            required
            clearable
            label="持股公司名称"
            placeholder="请输入持股公司名称"
          ></van-field>
          <van-field
            v-model="formData.cCclxzgqdczbl"
            required
            clearable
            label="出资比例(%)"
            placeholder="请输入出资比例"
          ></van-field>
        </div>

        <!--机器设备-->
        <div v-if="cclxCode == 11">
          <van-field
            v-model="formData.cSbmc"
            required
            clearable
            label="设备名称"
            placeholder="请输入设备名称"
          ></van-field>
        </div>

        <!--其他-->
        <div
          v-if="
            [10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 255].includes(
              Number(cclxCode)
            )
          "
        >
          <van-field
            v-model="formData.cMs"
            required
            clearable
            label="描述"
            placeholder="请输入描述"
          ></van-field>
        </div>
        <van-field
          v-if="formData.cCclx == 1 || formData.cCclx == 2"
          v-model="formData.cSqbqccje"
          required
          clearable
          label="财产价值(元)¥"
          placeholder="请输入财产价值(元)"
        ></van-field>
        <van-field
          v-if="formData.cCclx != 1 && formData.cCclx != 2"
          v-model="formData.cSqbqccje"
          required
          clearable
          label="财产价值(元)"
          placeholder="请输入财产价值(元)"
        ></van-field>
      </van-cell-group>
      <div class="fd-com-btn-container">
        <van-button
          v-if="formData.cDbppid"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addCcxsAndReturn"
        >
          确认
        </van-button>
        <van-button
          v-if="!formData.cDbppid"
          type="info"
          round
          plain
          :disabled="!saveBtnClickable"
          @click="addCcxsAndReturn"
        >
          添加
        </van-button>
        <van-button
          v-if="!formData.cDbppid"
          type="info"
          round
          :disabled="!saveBtnClickable"
          @click="addCcxsAndContinue"
        >
          确认并继续添加
        </van-button>
      </div>
  </div>
</template>

<script>
import MyTitle from "../../../components/common/myTitle";
import {
  typeCclx,
  typeBz,
  typeTddw,
  typeCar,
  typeSF,
} from "../../../filters/index";
import validate from "@/utils/validator/validator";
import {
  cclxRule,
  ccsyrRule,
  CzjzRule,
  SexzRule,
  bzRule,
  KhyhmcRule,
  KhyhzhRule,
  CphRule,
  FczhRule,
  FwzlwzRule,
  DzhqsRule,
  TdmjRule,
  tddwRule,
  GpmcRule,
  JjmcRule,
  JjslRule,
  ZqmcRule,
  ZqmzRule,
  CggsmcRule,
  CzblRule,
  MsRule,
  ClppRule,
  CqzhRule,
  khhmcRule,
  clgsdRule,
  fxdwRule,
  fwzlRule,
  tdgsRule,
  CsbmcRule,
} from "@/utils/validator/rules";
import { CgslRule, GpdmRule } from "../../../utils/validator/rules";
import { mapGetters } from "vuex";
import {
  addDbCcxs,
  addXcxCcxs,
  getBsqrs,
  getXcxSqrs,
  getCcxs,
  getXcxCcxs,
  getBgdbzt,
} from "../../../api/guarantee";

export default {
  components: {
    MyTitle,
  },
  data() {
    return {
      dbid: "",
      showCCLX: false, // 财产类型
      showBZLX: false, // 币种类型
      showCLLX: false, // 车辆类型
      showTDDW: false, // 土地单位类型
      showCCSYR: false, // 财产所属人员
      showKhhszd: false, //开户行所在地
      columnsBSQRS: [],
      formData: {
        cDbppid: null, // id
        cDbId: "", // 担保id
        cCclx: "4", // 财产类型
        cCclxText: "房产", // 财产类型文字描述
        cSqdbccyyz: "", // 申请担保财产拥有者id
        cSqdbccyyzText: "", // 财产拥有者文字姓名
        cSqbqccje: "", // 申请保全财产金额
        /*现金*/
        cXjzje: "", // 现金金额
        cCclxzbz: "", // 现金单位(币种),
        cCclxzbzText: "请选择币种", // 现金单位描述
        /*银行存款*/
        cKhhmc: "", // 开户行名称
        cYhckzkhzh: "", // 开户账号
        cYhckzckje: "", // 开户金额
        /*币种参数共用现金情况的币种参数*/
        /*开户行所在地*/
        cKhhszd: "",
        cKhhszdText: "",
        /*车辆*/
        cCclxzclpp: "", // 车辆品牌
        cCclxcllx: "", // 车辆类型
        cCclxcllxText: "请选择车辆类型", // 车辆类型文字描述
        cCklxzcldcph: "", // 车牌号
        /*房产*/
        cCclxfcdz: "", // 房产地址
        cCclxfczh: "", // 房产证号
        /*土地*/
        cCclxtdddz: "", // 土地地址
        cCclxtdmj: "", // 土地面积
        cYhckzckdw: "", // 土地面积单位
        cYhckzckdwText: "请选择土地面积单位", // 土地面积单位描述
        cCclxtddcqzh: "", // 土地产权证号
        /*股票*/
        cCclxzgpdgpmc: "", // 股票名称
        cCclxzgqdgsxx: "", // 股票代码
        cCclxzgpdcgsl: "", // 持股数量
        /*基金*/
        cCclxzjjdjjmc: "", // 基金名称
        cCclxzjjdjjsl: "", // 基金数量
        /*债券*/
        cCclxzzwdzqmc: "", // 债券名称
        cCclxzzwdzqmz: "", // 债券面值
        /*股权*/
        cCclxzgqdcggs: "", // 持股公司名称
        cCclxzgqdczbl: "", // 持股公司出资比例

        /*机器设备*/
        cSbmc: "", //设备名称

        /*其他*/
        cMs: "", // 描述
      },
      cclxCode: 4,
      saveBtnClickable: true, // 保存按钮是否可以点击

      fromSQBG: sessionStorage.getItem("fromSQBG"),
      cDbzt: "",
    };
  },
  computed: {
    ...mapGetters([
      "codeList_112000",
      "codeList_119000",
      "codeList_805000",
      "codeList_131000",
      "codeList_132000",
    ]),
  },
  methods: {
    //修改重新申请的状态
    changeDbstate: function () {
      if (this.fromSQBG !== "true" && this.cDbzt === "6") {
        getBgdbzt({ dbid: this.dbid })
          .then((res) => {})
          .catch(function (error) {
            console.log(error);
          });
      }
    },
    /*开户行所在地的省份*/
    confirmKhhszd(item) {
      this.showKhhszd = false;
      this.formData.cKhhszd = item.keyId;
      this.formData.cKhhszdText = item.text;
    },
    onCCLXConfirm: function (item) {
      this.clearCCXSData();
      if (item.keyId == 5) {
        this.formData.cYhckzckdw = 1;
        this.formData.cYhckzckdwText = "平方米";
      }
      this.initCCXSData(sessionStorage.getItem("ccxsId"));
      this.showCCLX = false;
      this.formData.cCclx = item.keyId;
      this.formData.cCclxText = item.text;
      this.cclxCode = item.keyId;
    },
    onBZConfirm: function (item) {
      this.showBZLX = false;
      this.formData.cCclxzbz = item.keyId;
      this.formData.cCclxzbzText = item.text;
    },
    onCLLXConfirm: function (item) {
      this.showCLLX = false;
      this.formData.cCclxcllx = item.keyId;
      this.formData.cCclxcllxText = item.text;
    },
    onTDDWLXConfirm: function (item) {
      this.showTDDW = false;
      this.formData.cYhckzckdw = item.keyId;
      this.formData.cYhckzckdwText = item.text;
    },
    onCCSYRConfirm: function (item) {
      this.formData.cSqdbccyyz = item.keyId;
      this.formData.cSqdbccyyzText = item.text;
      this.showCCSYR = false;
    },
    onSubmit: function () {
      this.saveBtnClickable = false;
      let ccxsId = sessionStorage.getItem("ccxsId");
      if (
        ccxsId != "" &&
        ccxsId != undefined &&
        ccxsId != null &&
        ccxsId != "undefined"
      ) {
        // 如果sqrId有值代表是更新
        this.formData.cDbppid = ccxsId;
      }
      let postData = {
        cDbId: this.formData.cDbId, // 担保id
        cCclx: this.formData.cCclx, // 财产类型
        cSqdbccyyz: this.formData.cSqdbccyyz, // 申请担保财产拥有者
        cSqbqccje: this.formData.cSqbqccje, // 申请保全财产金额
        nValid: 1,
      };
      if (this.formData.cDbppid != null) {
        postData.cDbppid = this.formData.cDbppid;
      }
      if (this.cclxCode == 1) {
        // 现金
        postData.cXjzje = this.formData.cXjzje; // 现金金额
        postData.cCclxzbz = this.formData.cCclxzbz; // 币种
      }
      if (this.cclxCode == 2) {
        // 银行贷款
        postData.cGsd = this.formData.cKhhszd;
        postData.cKhhmc = this.formData.cKhhmc; // 开户行名称
        postData.cYhckzkhzh = this.formData.cYhckzkhzh; // 开户账号
        postData.cYhckzckje = this.formData.cYhckzckje; // 开户金额
        postData.cCclxzbz = this.formData.cCclxzbz; // 币种
      }
      if (this.cclxCode == 3) {
        // 车辆
        postData.cGsd = this.formData.cKhhszd;
        postData.cCclxzclpp = this.formData.cCclxzclpp; // 车辆品牌
        postData.cCclxcllx = this.formData.cCclxcllx; // 车辆类型
        postData.cCklxzcldcph = this.formData.cCklxzcldcph; // 车牌号
      }
      if (this.cclxCode == 4) {
        // 房产
        postData.cGsd = this.formData.cKhhszd;
        postData.cCclxfcdz = this.formData.cCclxfcdz; // 房产地址
        postData.cCclxfczh = this.formData.cCclxfczh; // 房产证号
      }
      if (this.cclxCode == 5) {
        // 土地
        postData.cGsd = this.formData.cKhhszd;
        postData.cCclxtdddz = this.formData.cCclxtdddz; // 土地地址
        postData.cCclxtdmj = this.formData.cCclxtdmj; // 土地面积
        postData.cYhckzckdw = this.formData.cYhckzckdw; // 土地面积单位
        postData.cCclxtddcqzh = this.formData.cCclxtddcqzh; // 土地产权证号
      }
      if (this.cclxCode == 6) {
        // 股票
        postData.cGsd = this.formData.cKhhszd;
        postData.cCclxzgpdgpmc = this.formData.cCclxzgpdgpmc; // 股票名称
        postData.cCclxzgqdgsxx = this.formData.cCclxzgqdgsxx; // 股票代码
        postData.cCclxzgpdcgsl = this.formData.cCclxzgpdcgsl; // 持股数量
      }
      if (this.cclxCode == 7) {
        // 基金
        postData.cGsd = this.formData.cKhhszd;
        postData.cCclxzjjdjjmc = this.formData.cCclxzjjdjjmc; // 基金名称
        postData.cCclxzjjdjjsl = this.formData.cCclxzjjdjjsl; // 基金数量
      }
      if (this.cclxCode == 8) {
        // 债券
        postData.cGsd = this.formData.cKhhszd;
        postData.cCclxzzwdzqmc = this.formData.cCclxzzwdzqmc; // 债券名称
        postData.cCclxzzwdzqmz = this.formData.cCclxzzwdzqmz; // 债券面值
      }
      if (this.cclxCode == 9) {
        // 股权
        postData.cGsd = this.formData.cKhhszd;
        postData.cCclxzgqdcggs = this.formData.cCclxzgqdcggs; // 持股公司名称
        postData.cCclxzgqdczbl = this.formData.cCclxzgqdczbl; // 持股公司出资比例
      }

      if (this.cclxCode == 11) {
        postData.cSbmc = this.formData.cSbmc; // 描述
      }

      if (
        [10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 255].includes(
          Number(this.cclxCode)
        )
      ) {
        postData.cMs = this.formData.cMs; // 描述
      }
      if (this.cclxCode != 0) {
        var fnGet = this.fromSQBG === "true" ? addXcxCcxs : addDbCcxs;
        return fnGet({ dbid: this.formData.cDbId }, postData)
          .then((res) => {
            this.changeDbstate();
            this.$notify({
              type: "success",
              message: "操作成功",
            });
          })
          .catch(function (error) {
            console.log(error);
          });

        /*return this.$axios.post('ssbq/api/xcx/dbCcxs?dbid=' + this.formData.cDbId, postData)
                        .then(res => {
                        }).catch(function (error) {
                            console.log(error)
                        });*/
      }
    },
    addCcxsAndReturn: function () {
      const validated = this.validateFormData();
      validated.then(() => {
        this.onSubmit().then(() => {
          this.$router.push("/guaranteeInfo");
        });
      });
    },
    addCcxsAndContinue: function () {
      const validated = this.validateFormData();
      validated.then(() => {
        this.onSubmit().then(() => {
          // this.clearCCXSData();
          setTimeout(() => {
            window.location.reload();
          }, 500);
        });
      });
    },
    initColumnsBSQRS: function () {
      var fnGet = this.fromSQBG === "true" ? getXcxSqrs : getBsqrs;
      fnGet({ dbid: this.formData.cDbId })
        .then((res) => {
          let ccxsId = sessionStorage.getItem("ccxsId");
          let sqrs = res.data;
          sqrs.forEach((item) => {
            let temp = {
              keyId: item.cDbDsrid,
            };
            if (item.cDsrlx == 1) {
              // 自然人
              temp.text = item.cDsrxm;
            } else {
              // 法人 非法人
              temp.text = item.cQymc;
            }
            this.columnsBSQRS.push(temp);
          });
          this.initCCXSData(ccxsId, true);
        })
        .catch(function (error) {
          console.log(error);
        });

      /*this.$axios.get('ssbq/api/ssdb/bsqrs?dbid=' + this.formData.cDbId)
                    .then(res => {
                    }).catch(function (error) {
                    console.log(error)
                });*/
    },
    initCCXSData: function (ccxsId, firstVisit) {
      if (!ccxsId || ccxsId == "" || ccxsId == "undefined") {
        return;
      }
      this.cDbppid = ccxsId;

      var fnGet = this.fromSQBG === "true" ? getXcxCcxs : getCcxs;
      fnGet({ id: ccxsId })
        .then((res) => {
          let data = res.data;
          if (firstVisit || this.cclxCode == data.cCclx) {
            this.formData.cDbId = data.cDbId; // 担保id
            this.formData.cCclx = data.cCclx; // 财产类型
            this.cclxCode = data.cCclx; // 财产类型,控制页面分组显示
            this.formData.cCclxText = typeCclx(data.cCclx); // 财产类型文字描述
            this.formData.cSqdbccyyz = data.cSqdbccyyz; // 申请担保财产拥有者id
            this.formData.cSqbqccje = data.cSqbqccje; // 申请保全财产金额
            this.formData.cKhhszd = data.cGsd;
            this.formData.cKhhszdText = typeSF(data.cGsd);
            /*现金*/
            this.formData.cXjzje = data.cXjzje; // 现金金额
            this.formData.cCclxzbz = data.cCclxzbz; // 现金单位(币种),
            this.formData.cCclxzbzText = typeBz(data.cCclxzbz); // 现金单位描述
            /*银行存款*/
            this.formData.cKhhmc = data.cKhhmc; // 开户行名称
            this.formData.cYhckzkhzh = data.cYhckzkhzh; // 开户账号
            this.formData.cYhckzckje = data.cYhckzckje; // 开户金额
            /*币种参数共用现金情况的币种参数*/
            /*车辆*/
            this.formData.cCclxzclpp = data.cCclxzclpp; // 车辆品牌
            this.formData.cCclxcllx = data.cCclxcllx; // 车辆类型
            this.formData.cCclxcllxText = typeCar(data.cCclxcllx); // 车辆类型文字描述
            this.formData.cCklxzcldcph = data.cCklxzcldcph; // 车牌号
            /*房产*/
            this.formData.cCclxfcdz = data.cCclxfcdz; // 房产地址
            this.formData.cCclxfczh = data.cCclxfczh; // 房产证号
            /*土地*/
            this.formData.cCclxtdddz = data.cCclxtdddz; // 土地地址
            this.formData.cCclxtdmj = data.cCclxtdmj; // 土地面积
            this.formData.cYhckzckdw = data.cYhckzckdw; // 土地面积单位
            this.formData.cYhckzckdwText = typeTddw(data.cYhckzckdw); // 土地面积单位描述
            this.formData.cCclxtddcqzh = data.cCclxtddcqzh; // 土地产权证号
            /*股票*/
            this.formData.cCclxzgpdgpmc = data.cCclxzgpdgpmc; // 股票名称
            this.formData.cCclxzgqdgsxx = data.cCclxzgqdgsxx; // 股票代码
            this.formData.cCclxzgpdcgsl = data.cCclxzgpdcgsl; // 持股数量
            /*基金*/
            this.formData.cCclxzjjdjjmc = data.cCclxzjjdjjmc; // 基金名称
            this.formData.cCclxzjjdjjsl = data.cCclxzjjdjjsl; // 基金数量
            /*债券*/
            this.formData.cCclxzzwdzqmc = data.cCclxzzwdzqmc; // 债券名称
            this.formData.cCclxzzwdzqmz = data.cCclxzzwdzqmz; // 债券面值
            /*股权*/
            this.formData.cCclxzgqdcggs = data.cCclxzgqdcggs; // 持股公司名称
            this.formData.cCclxzgqdczbl = data.cCclxzgqdczbl; // 持股公司出资比例

            /*机械设备*/
            this.formData.cSbmc = data.cSbmc; //设备名称

            /*其他*/
            this.formData.cMs = data.cMs; // 描述

            Object.keys(this.columnsBSQRS).forEach((key) => {
              if (
                this.columnsBSQRS[key].hasOwnProperty("keyId") &&
                this.columnsBSQRS[key]["keyId"] == data.cSqdbccyyz
              ) {
                console.log(
                  this.formData.cSqdbccyyzText,
                  this.columnsBSQRS[key].text
                );
                this.formData.cSqdbccyyzText = this.columnsBSQRS[key].text;
              }
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });

      /*this.$axios.get('ssbq/api/ssdb/ccxs?id=' + ccxsId)
                    .then(res => {
                    }).catch(function (error) {
                    console.log(error)
                });*/
    },
    clearCCXSData: function () {
      let formData = this.formData;
      for (let key in formData) {
        if (key != "cDbId") {
          formData[key] = "";
        }
      }
    },
    validateFormData: function () {
      let descriptor = {
        cCclx: cclxRule,
        cSqdbccyyz: ccsyrRule,
        cSqbqccje: new CzjzRule(true),
      };
      if (this.formData.cCclx === 1) {
        descriptor.cXjzje = new SexzRule(true);
        descriptor.cCclxzbz = bzRule;
      }
      if (this.formData.cCclx == 2) {
        descriptor.cKhhszd = khhmcRule;
        descriptor.cKhhmc = new KhyhmcRule(true);
        descriptor.cYhckzkhzh = new KhyhzhRule(true);
        descriptor.cYhckzckje = new SexzRule(true);
        descriptor.cCclxzbz = bzRule;
      }
      if (this.formData.cCclx == 3) {
        descriptor.cKhhszd = clgsdRule;
        descriptor.cCclxzclpp = new ClppRule(false);
        descriptor.cCklxzcldcph = new CphRule(true);
      }
      if (this.formData.cCclx == 4) {
        descriptor.cKhhszd = fwzlRule;
        descriptor.cCclxfcdz = new FwzlwzRule(true);
        descriptor.cCclxfczh = new FczhRule(false);
      }
      if (this.formData.cCclx == 5) {
        descriptor.cKhhszd = tdgsRule;
        descriptor.cCclxtdddz = new DzhqsRule(true);
        descriptor.cCclxtdmj = new TdmjRule(true);
        descriptor.cCclxtddcqzh = new CqzhRule(false);
        descriptor.cYhckzckdw = tddwRule;
      }
      if (this.formData.cCclx == 6) {
        descriptor.cKhhszd = fxdwRule;
        // 股票名称
        descriptor.cCclxzgpdgpmc = new GpmcRule(true);
        // 股票代码
        descriptor.cCclxzgqdgsxx = new GpdmRule(false);
        // 持股数量
        descriptor.cCclxzgpdcgsl = new CgslRule(false);
      }
      if (this.formData.cCclx == 7) {
        descriptor.cKhhszd = fxdwRule;
        // 基金名称
        descriptor.cCclxzjjdjjmc = new JjmcRule(true);
        // 基金数量
        descriptor.cCclxzjjdjjsl = new JjslRule(false);
      }
      if (this.formData.cCclx == 8) {
        descriptor.cKhhszd = fxdwRule;
        descriptor.cCclxzzwdzqmc = new ZqmcRule(true);
        descriptor.cCclxzzwdzqmz = new ZqmzRule(true);
      }
      if (this.formData.cCclx == 9) {
        descriptor.cKhhszd = fxdwRule;
        descriptor.cCclxzgqdcggs = new CggsmcRule(true);
        descriptor.cCclxzgqdczbl = new CzblRule(true);
      }

      if (this.formData.cCclx == 11) {
        descriptor.cSbmc = new CsbmcRule(true);
      }

      if (
        [10, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 255].includes(
          Number(this.formData.cCclx)
        )
      ) {
        descriptor.cMs = new MsRule(true);
      }
      if (typeof this.formData.cSqdbccyyz == "undefined") {
        this.$notify("没有财产所有人，请添加被申请人");
        return;
      }
      const validated = validate(descriptor, this.formData);
      return validated;
    },
    initCodeType() {
      this.$store.dispatch("GetCodeType", 119000);
      this.$store.dispatch("GetCodeType", 805000);
      this.$store.dispatch("GetCodeType", 112000);
      this.$store.dispatch("GetCodeType", 131000);
      this.$store.dispatch("GetCodeType", 132000);
    },
  },
  created() {
    this.cDbzt = this.$route.query.cDbzt;
    this.initCodeType();
    let ccxsId = sessionStorage.getItem("ccxsId");
    this.formData.cDbppid = ccxsId;
    let currentDbid = JSON.parse(sessionStorage.getItem("currentDbid"));
    this.formData.cDbId = currentDbid;
    this.dbid = currentDbid;
    this.initColumnsBSQRS();
  },
  //  beforeRouteEnter (to, from, next) {
  //     next(vm => {
  //         if(from.name == 'guaranteeInfo'){
  //             if(vm.formData.cSqdbccyyzText == ""){

  //             }
  //         }
  //     })
  // },
};
</script>
